import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { first } from 'rxjs/operators';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DripCampaignInstance, DripCampaignEvent } from '@app/_models/drip-campaign';
import { DripCampaignService } from '../drip-campaign.service';
import { AlertService } from '@app/_services';

@Component({
  selector: 'app-drip-campaign-instance-detail',
  templateUrl: './drip-campaign-instance-detail.component.html',
  providers: [MessageService, ConfirmationService],
  standalone: false
})
export class DripCampaignInstanceDetailComponent implements OnInit {

  @Input() instance: DripCampaignInstance;
  @Output() closed = new EventEmitter<void>();

  detail: DripCampaignInstance = null;
  events: DripCampaignEvent[] = [];
  loading = true;

  cancelReason = '';
  showCancelConfirm = false;

  taskSourceLabels: { [key: number]: string } = {
    1: 'Note', 2: 'Reservation', 3: 'Guest',
    4: 'Quote', 5: 'Owner Lead', 6: 'Owner Statement', 7: 'Onboarding', 8: 'Msg', 9: 'Property'
  };

  taskSourceRoutes: { [key: number]: string } = {
    4: '/quotes',
    5: '/owner-lead-profile'
  };

  constructor(
    private svc: DripCampaignService,
    private alertService: AlertService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.loading = true;
    this.svc.getInstance(this.instance.dripCampaignInstanceId).pipe(first()).subscribe(
      (inst: DripCampaignInstance) => {
        this.detail = inst;
        this.events = inst?.events ?? [];
        this.loading = false;
      },
      (err: any) => {
        this.alertService.error(err);
        this.detail = this.instance;
        this.loading = false;
      }
    );
  }

  onClose() {
    this.closed.emit();
  }

  onPause() {
    this.svc.pauseInstance(this.detail.dripCampaignInstanceId).pipe(first()).subscribe(
      () => {
        this.detail.status = 'PAUSED';
        this.messageService.add({ severity: 'success', summary: 'Paused', detail: 'Campaign paused.', life: 3000 });
      },
      (err: any) => this.alertService.error(err)
    );
  }

  onResume() {
    this.svc.resumeInstance(this.detail.dripCampaignInstanceId).pipe(first()).subscribe(
      () => {
        this.detail.status = 'ACTIVE';
        this.messageService.add({ severity: 'success', summary: 'Resumed', detail: 'Campaign resumed.', life: 3000 });
      },
      (err: any) => this.alertService.error(err)
    );
  }

  onCancelPrompt() {
    this.cancelReason = '';
    this.showCancelConfirm = true;
  }

  confirmCancel() {
    this.svc.cancelInstance(this.detail.dripCampaignInstanceId, this.cancelReason).pipe(first()).subscribe(
      () => {
        this.detail.status = 'CANCELLED';
        this.showCancelConfirm = false;
        this.messageService.add({ severity: 'success', summary: 'Cancelled', detail: 'Campaign cancelled.', life: 3000 });
      },
      (err: any) => {
        this.alertService.error(err);
        this.showCancelConfirm = false;
      }
    );
  }

  getEntityRoute(): string | null {
    if (!this.detail) { return null; }
    const base = this.taskSourceRoutes[this.detail.taskSource];
    return base && this.detail.taskSourceId ? `${base}/${this.detail.taskSourceId}` : null;
  }

  getTaskSourceLabel(val: number): string {
    return this.taskSourceLabels[val] || ('Source ' + val);
  }
}
